export default __webpack_public_path__ + "static/media/bee-1.4af9a9a8.png";